<template>
	<div
			class="scroll-container pa-4 pa-md-8"
			:style="{
				height: $vuetify.breakpoint.smAndDown
					? 'calc(100dvh - 202px)'
					: 'calc(100dvh - 109px)'
			}"
	>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'BwScrollTabsContent'
};
</script>

<style>
.scroll-container {
	overflow-y: auto;
	position: relative;
}
</style>